export const articleRequired = (apiClient, locationIdContainers) => {
  return apiClient
    .call({
      endpoint: 'statsNew/articleRequired',
      data: { locationIdContainers }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      return res;
    })
    .catch(e => {
      throw e;
    });
};

export const articleMissing = (
  apiClient,
  locationIdContainers,
  locationIdWarehouses
) => {
  return apiClient
    .call({
      endpoint: 'statsNew/articleRequired',
      data: { locationIdContainers, locationIdWarehouses }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      return res;
    })
    .catch(e => {
      throw e;
    });
};

export const articleDistributor = (apiClient, locationIdContainers) => {
  return apiClient
    .call({
      endpoint: 'statsNew/articleDistributor',
      data: { locationIdContainers }
    })
    .then(res => {
      if (res.status !== 200) {
        throw res;
      }
      console.log('%cres.data :', 'background-color:orange;color:white;', res.data);
      return res;
    })
    .catch(e => {
      throw e;
    });
};



// WEBPACK FOOTER //
// ./app/actions/statsNew.js